module.exports = __webpack_public_path__ + "static/NQA_ISO27001_BW-ea5c90c67fbc81b67a3249a65559d5c8.svg";